export {
  useInvertedLocalize,
  type LocalizationMessages,
  type InvertedLocalize,
  invertedMessages,
} from './localization';
export { useSelector } from './redux';
export const urls = {
  Login: '/ECMv6/auth/login',
  'Update Password': '/ECMv6/auth/password-reset',
  'MFA Setup': '/ECMv6/auth/mfa-setup',
  'MFA Verification': '/ECMv6/auth/mfa-verification',
  Logout: '/ECM/logout/logout',
  LoginInit: '/ECM/login/init',
  ForgotPassword: '/ECM/maintenance/forgotpassword',
} as const;

const root = process.env.REACT_APP_AUTH_API ?? '';
const ecmV6Api = `${root}/ECMv6/api`;
const authms = `${ecmV6Api}/authms/api`;
const debug = `${root}/debug/api`;

export const baseUrl = {
  root,
  authms,
  debug,
};
